import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 定义路由
const routes = [

  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import('@/views/Notice.vue'),
    meta: { title: '公告' }
  },
  {
    path: '/NoticeDetail',
    name: 'NoticeDetail',
    component: () => import('@/views/NoticeDetail.vue'),
    meta: { title: '公告' }
  },
  {
    path: '/study',
    name: 'study',
    component: () => import('@/views/Study.vue'),
    meta: { title: '学习' }
  },
  {
    path: '/todayTasks',
    name: 'todayTasks',
    component: () => import('@/views/TodayTasks.vue'),
    meta: { title: '今日任务' }
  },
  {
    path: '/todayTasksSuccess',
    name: 'todayTasksSuccess',
    component: () => import('@/views/TodayTasksSuccess.vue'),
    meta: { title: '详情' }
  },
  {
    path: '/todayTasksView',
    name: 'todayTasksView',
    component: () => import('@/views/TodayTasksView.vue'),
    meta: { title: '详情' }
  },
  {
    path: '/taskVideo',
    name: 'taskVideo',
    component: () => import('@/views/TaskVideo.vue'),
    meta: { title: '任务列表' }
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('@/views/Main.vue'),
    meta: { title: '我的' }
  },
  {
    path: '/mainedit',
    name: 'mainedit',
    component: () => import('@/views/MainEdit.vue'),
    meta: { title: '个人信息' }
  },
  {
    path: '/password',
    name: 'password',
    component: () => import('@/views/Password.vue'),
    meta: { title: '修改密码' }
  },
    {
    path: '/studyrecords',
    name: 'studyrecords',
    component: () => import('@/views/StudyRecords.vue'),
    meta: { title: '学习记录' }
  },
      {
    path: '/studyranking',
    name: 'studyranking',
    component: () => import('@/views/StudyRanking.vue'),
    meta: { title: '学习排名' }
  },
    {
    path: '/studyrecordsview',
    name: 'studyrecordsview',
    component: () => import('@/views/StudyRecordsView.vue'),
    meta: { title: '学习记录详情' }
  },
    {
    path: '/studynotes',
    name: 'studynotes',
    component: () => import('@/views/StudyNotes.vue'),
    meta: { title: '学习心得' }
  },
    {
    path: '/studynotesview',
    name: 'studynotesview',
    component: () => import('@/views/StudyNotesView.vue'),
    meta: { title: '心得详情' }
  },
    {
    path: '/studynotesedit',
    name: 'studynotesedit',
    component: () => import('@/views/StudyNotesEdit.vue'),
    meta: { title: '编辑' }
  },
    {
    path: '/myexams',
    name: 'myexams',
    component: () => import('@/views/MyExams.vue'),
    meta: { title: '我的考试' }
  },
  {
    path: '/myexamsview',
    name: 'myexamsview',
    component: () => import('@/views/MyExamsView.vue'),
    meta: { title: '考试详情' }
  },
  {
    path: '/exam',
    name: 'exam',
    component: () => import('@/views/Exam.vue'),
    meta: { title: '答题' }
  },
  {
    path: '/examlist',
    name: 'examlist',
    component: () => import('@/views/ExamList.vue'),
    meta: { title: '考试' }
  },
  {
    path: '/examshow',
    name: 'examshow',
    component: () => import('@/views/ExamShow.vue'),
    meta: { title: '考试详情' }
  },

  {
    path: '/examsubmit',
    name: 'examsubmit',
    component: () => import('@/views/ExamSubmit.vue'),
    meta: { title: '成绩' }
  },
  
]

export default new Router({
  mode: 'hash',   // 或 'history'
  routes
})